<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="$route.meta.title"
          :link="[
            {
              text: $route.meta.title,
            },
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn class="ml-6" depressed dark color="#0D47A1" @click.stop="createState = !createState">
          <v-icon left>add</v-icon>Thêm công việc
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pt-6 px-6 mx-4 mb-6 elevation-0">
      <TaskNewFilter :tasks="tasks" @onFilterChanged="onFilter" ref="taskNewFilter"></TaskNewFilter>
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <TaskNewDataTable
        :tasks="tasks"
        :isLoading="isLoading"
        @onDelete="confirmDelete"
        @onChange="changeStatus"
        @viewTask="viewTaskDetail"
      />
    </v-card>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6 text-uppercase">XÓA CÔNG VIỆC</v-card-title>
        <v-card-text>Bạn có chắc chắn muốn xoá công việc này không?</v-card-text>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn class="text-none text-uppercase" @click="dialog = false" :disabled="isDeleting" outlined>Không</v-btn>
          <v-btn color="primary text-none text-uppercase" elevation="0" :loading="isDeleting" @click="deleteTask"
            >Có</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <TaskNewDialog :state="createState" @done="onFilter" />
    <TaskNewDialogChangeStatus
      v-if="selectedTask"
      :task="selectedTask"
      :dialog="changeStatusDialog"
      @close="changeStatusDialog = false"
      @updated="onTaskUpdated"
    />
    <TaskNewDialogDetail
      v-if="selectedTask"
      :task="selectedTask"
      :dialog="detailDialog"
      @close="detailDialog = false"
      @updated="onTaskUpdated"
      @edit="editTask"
    />
    <TaskNewDialogEdit
      v-if="selectedTaskEdit"
      :dialog="editDialog"
      :task="selectedTaskEdit"
      @close="editDialog = false"
      @updated="onTaskUpdated"
      :key="selectedTaskEdit._id"
    />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TaskNewDataTable from '@/modules/task-new/TaskNewDataTable.vue'
import TaskNewDialog from '@/modules/task-new/TaskNewDialog.vue'
import TaskNewDialogChangeStatus from '@/modules/task-new/TaskNewDialogChangeStatus.vue'
import TaskNewDialogDetail from '@/modules/task-new/TaskNewDialogDetail.vue'
import TaskNewDialogEdit from '@/modules/task-new/TaskNewDialogEdit.vue'
import TaskNewFilter from '@/modules/task-new/TaskNewFilter.vue'
import { mapGetters, mapState } from 'vuex'

// import { mapGetters } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    TaskNewDialog,
    TaskNewDialogDetail,
    TaskNewFilter,
    TaskNewDataTable,
    TaskNewDialogEdit,
    TaskNewDialogChangeStatus,
  },
  data() {
    return {
      createState: false,
      isLoading: false,
      dialog: false,
      selectedTaskId: null,
      isDeleting: false,
      selectedTask: null,
      selectedTaskEdit: null,
      detailDialog: false,
      changeStatusDialog: false,
      editDialog: false,
    }
  },
  computed: {
    ...mapState('tasknew', ['tasks']),
    ...mapGetters('auth', ['user']),
  },
  mounted() {
    this.fetchTasks()
  },
  props: {
    state: Boolean,
  },
  methods: {
    onTaskUpdated() {
      this.fetchTasks()
      this.detailDialog = false
    },
    async viewTaskDetail(task) {
      this.selectedTask = task
      this.$nextTick(() => {
        this.detailDialog = true
      })
    },
    async editTask(task) {
      console.log('tasktoedit', task)
      this.selectedTaskEdit = task
      this.$nextTick(() => {
        this.detailDialog = false
        this.editDialog = true
      })
    },
    async fetchTasks(filter = {}) {
      this.isLoading = true
      await this.$store.dispatch('tasknew/findTaskByFilter', filter)
      this.isLoading = false
    },
    onFilter(filter) {
      this.fetchTasks(filter)
    },
    confirmDelete(item) {
      this.selectedTaskId = item._id
      this.dialog = true
    },
    changeStatus(task) {
      console.log('taskchange', task)
      this.selectedTask = task
      this.$nextTick(() => {
        this.changeStatusDialog = true
      })
    },
    async deleteTask() {
      try {
        this.isDeleting = true
        console.log('this.selectedTaskId', this.selectedTaskId)
        const res = await this.$store.dispatch('tasknew/deleteTaskNew', this.selectedTaskId)
        if (res) {
          this.$alert.success('Xoá thành công')
          this.fetchTasks()
        } else {
          this.$alert.error('Xoá thất bại')
        }
      } catch (err) {
        this.$alert.error('Đã xảy ra lỗi khi xoá')
      } finally {
        this.dialog = false
        this.isDeleting = false
        this.selectedTaskId = null
      }
    },
  },
}
</script>
